import React from 'react';
import styled from 'styled-components';

 const Content = styled.div`
  width: 100%;
  min-height: 160px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
  border: 2px solid #e3f2fd;
  border-radius: 16px;
  padding: 28px 24px;
  box-shadow: 0 2px 8px rgba(3, 169, 244, 0.08);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: linear-gradient(180deg, #03a9f4 0%, #0288d1 100%);
  }
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(3, 169, 244, 0.15);
    border-color: #03a9f4;
  }
  
  p {
    font-size: 14px;
    color: #546881;
    line-height: 20px;
    font-weight: 500;
    margin-bottom: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  h3 {
    margin-top: 8px;
    font-size: 32px;
    color: #03a9f4;
    line-height: 40px;
    font-weight: 700;
  }
`;

const Card = ({ totalCount, text }) => {
  return (
    <Content>
      <div>
        <p>{text}</p>
        <h3>{totalCount}</h3>
      </div>
    </Content>
  );
};

export default Card;
